var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectAppContent, selectStyles } from "@adm-media/adam-store-plugin";
import { Typography, Card, Button } from "antd";
import { BlockWrapper } from "../../wrappers/BlockWrapper/BlockWrapper";
import { useRef } from "react";
import { useAnimationClassName } from "../../../hooks/useAnimationClassName";
import "./Takeaways.scss";
import usePages from "../../../hooks/usePages";
var Takeaways = function (_a) {
    var _b;
    var _c = _a.viewType, viewType = _c === void 0 ? "list" : _c, title = _a.title, animation = _a.animation, props = __rest(_a, ["viewType", "title", "animation"]);
    var contents = useSelector(selectAppContent);
    var _d = usePages(), filter = _d.filter, getMediaUrl = _d.getMediaUrl, handleLink = _d.handleLink;
    var styles = useSelector(selectStyles);
    var titleRef = useRef(null);
    var titleAnimationClass = useAnimationClassName({ ref: titleRef, animation: animation });
    var contentRef = useRef(null);
    var contentAnimationClass = useAnimationClassName({ ref: contentRef, animation: animation });
    var baseClass = "block-takeaways";
    var blockClassName = classNames(baseClass);
    var takeaways = filter("takeaway");
    var itemsClassNames = classNames("takeaways__list", (_b = {},
        _b["".concat(baseClass, "__list--grid")] = viewType === "grid",
        _b["".concat(baseClass, "__list--list")] = viewType === "list",
        _b));
    var blockTitle = contents.takeaways_title;
    var takeawaysCount = (takeaways === null || takeaways === void 0 ? void 0 : takeaways.length) || 0;
    return takeawaysCount ? (_jsxs(BlockWrapper, __assign({ id: "takeaways", style: !styles.show_takeaways_section || !takeawaysCount ? { display: "none" } : undefined, className: blockClassName }, props, { "data-testid": "block-takeaways" }, { children: [blockTitle && (_jsx(Typography.Title, __assign({ className: "".concat(baseClass, "__title ").concat(titleAnimationClass), ref: titleRef, style: { marginBottom: 20 }, level: props.titleLevel || 2 }, { children: blockTitle }))), _jsx("div", __assign({ ref: contentRef, className: "".concat(itemsClassNames, " ").concat(contentAnimationClass) }, { children: takeaways === null || takeaways === void 0 ? void 0 : takeaways.map(function (item, index) {
                    var _a;
                    var _b;
                    var mediaSrc = getMediaUrl({ filter: "card_media", item: item });
                    var _c = handleLink(item), linkTarget = _c.linkTarget, cardTitle = _c.cardTitle, handleCardClick = _c.handleCardClick;
                    var cardClassName = classNames("".concat(baseClass, "__card"), (_a = {},
                        _a["".concat(baseClass, "__card--reverse")] = viewType === "list" && index % 2 === 1,
                        _a));
                    return (_jsx(Card, __assign({ className: cardClassName, bordered: false, cover: _jsx("div", __assign({ className: "".concat(baseClass, "__cover") }, { children: _jsx("img", { draggable: false, alt: item.title, src: mediaSrc }) })), onClick: handleCardClick, style: handleCardClick ? { cursor: "pointer" } : undefined }, { children: _jsxs("div", __assign({ className: "".concat(baseClass, "__card--content") }, { children: [_jsx("div", __assign({ className: "".concat(baseClass, "__card--content--text") }, { children: _jsx(Card.Meta, { title: cardTitle, description: item.subtitle }) })), handleCardClick ? (_jsx("div", __assign({ className: "".concat(baseClass, "__card--content--cta") }, { children: _jsx(Button, __assign({ onClick: handleCardClick, target: linkTarget, className: "".concat(baseClass, "__card--cta-btn") }, { children: item.slide_cta_text || "More info" })) }))) : null] })) }), "takeaway-item-".concat((_b = item.id) !== null && _b !== void 0 ? _b : index)));
                }) }))] }))) : null;
};
export default Takeaways;
